import styled from 'styled-components';

export const Container = styled.div<{ isSm: boolean }>`
  padding: ${props => props.theme.spacing.s8}
    ${props => (props.isSm ? props.theme.spacing.s16 : props.theme.spacing.xs)};
`;
